module.exports = __webpack_public_path__ + "img/17a003-03.4c3e53e7.png";